export default {
  "content": "<path d=\"M9 20c0 .55.45 1 1 1s1-.45 1-1v-3c.73-2.58 3.07-3.47 5.17-3l-.88.88a.996.996 0 101.41 1.41l2.59-2.59a.996.996 0 000-1.41L16.7 9.7a.996.996 0 00-1.41 0 .996.996 0 000 1.41l.88.89c-1.51-.33-3.73.08-5.17 1.36V6.83l.88.88a.996.996 0 101.41-1.41L10.7 3.71a.996.996 0 00-1.41 0L6.71 6.29A.996.996 0 108.12 7.7L9 6.83V20z\"/>",
  "attrs": {
    "viewBox": "0 0 24 24",
    "data-testid": "ForkRightRoundedIcon"
  }
};